/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Servis_S8_Body_StrongInputs */

const tr_servis_s8_body_strong = /** @type {(inputs: Servis_S8_Body_StrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`72 saat içinde`)
};

const en_servis_s8_body_strong = /** @type {(inputs: Servis_S8_Body_StrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`within 72 hours`)
};

const de_servis_s8_body_strong = /** @type {(inputs: Servis_S8_Body_StrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`innerhalb von 72 Stunden`)
};

const ru_servis_s8_body_strong = /** @type {(inputs: Servis_S8_Body_StrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`в течение 72 часов`)
};

/**
* | output |
* | --- |
* | "within 72 hours" |
*
* @param {Servis_S8_Body_StrongInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const servis_s8_body_strong = /** @type {((inputs?: Servis_S8_Body_StrongInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Servis_S8_Body_StrongInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_servis_s8_body_strong(inputs)
	if (locale === "de") return de_servis_s8_body_strong(inputs)
	if (locale === "ru") return ru_servis_s8_body_strong(inputs)
	return tr_servis_s8_body_strong(inputs)
});